import React from "react"
import styled from "styled-components"
import mesageIcon from "../../assist/icons/about/masej.svg"
import mission from "../../assist/icons/about/mission.svg"
import AboutImagesText from "./AboutImagesText"
import { useStaticQuery, graphql } from "gatsby"
const getImages = graphql`
  {
    img1: strapiAboutPageImages(name: { eq: "imageSection1" }) {
      image {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
    }
    img2: strapiAboutPageImages(name: { eq: "imageSection2" }) {
      image {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
    }
    imgMobile1: strapiAboutPageImages(name: { eq: "aboutMobile1" }) {
      image {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
    }
    imgMobile2: strapiAboutPageImages(name: { eq: "aboutMobile2" }) {
      image {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
    }
  }
`
const AboutImages = ({ lang }) => {
  const images = useStaticQuery(getImages)

  const data = [
    {
      logo: mesageIcon,
      ar: {
        Title: "رسالتنا",
        Desc: " إنسان أفضل لمجتمع أرقى",
      },
      en: {
        Title: "Our Message",
        Desc: " A Better Person for a Higher Society",
      },
      tr: {
        Title: "Mesajımız",
        Desc: "  Seviyeli bir toplum  için daha iyi bir insan...",
      },
      fullImage: images.img1.image.childImageSharp.fluid,
      mobileImage: images.imgMobile1.image.childImageSharp.fluid,
    },
    {
      logo: mission,
      ar: {
        Title: "مهمتنا",
        Desc:
          "مؤسسة الرسالة متخصصة لإنقاذ الأرواح وتخفیف المعاناة من خلال تأمین سبل العیش والأمن الغذائي والمیاه والصرف الصحي وخدمات الرعایة الصحیة، والتدریب، وبرامج الإغاثة والتنمیة",
      },
      en: {
        Title: "Our Mission",
        Desc:
          "Al-Resala Foundation is dedicated to saving lives and alleviating suffering through securing livelihoods, food security, water and sanitation, health care services, training, relief and development programs.",
      },
      tr: {
        Title: "Görevimiz",
        Desc:
          "Alrisele derneği, yaşam kaynakları,gıda güvenliği,su, kanalizasyon , sağlık bakım  hizmetleri , eğitimler , yardım ve geliştirma  programları temin ederek acıyı hafifletmek ve hayatları kurtarmak  için kendini adamış bir dernektir. ",
      },

      fullImage: images.img2.image.childImageSharp.fluid,
      mobileImage: images.imgMobile2.image.childImageSharp.fluid,
    },
  ]
  return (
    <Wraper>
      <div className="continer">
        <div className="content">
          <AboutImagesText
            logo={data[0].logo}
            title={data[0][lang].Title}
            text={data[0][lang].Desc}
            fullImage={data[0].fullImage}
            mobileImage={data[0].mobileImage}
          />
          <div className="divider"></div>
          <AboutImagesText
            logo={data[1].logo}
            title={data[1][lang].Title}
            text={data[1][lang].Desc}
            fullImage={data[1].fullImage}
            mobileImage={data[1].mobileImage}
            img2
          />
        </div>
      </div>
    </Wraper>
  )
}

export default AboutImages
const Wraper = styled.section`
  padding: 50px 0;
  .divider {
    margin: 50px 0;
  }
`
